//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headerTitle from "@/components/block/components/header.vue";
//import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import footMore from "@/components/block/components/footMore.vue";

export default {
  components: {
    Swiper,
    SwiperSlide,
    headerTitle,
    footMore
  },
  props: {
    listsData: {
      type: Object,
      required: true
    },
    blocktitleClass: {
      type: String,
      required: false
    },
    moreClass: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      swiperOption: {
        // slidesPerView: "auto",
        slidesPerView: 1.5,
        freeMode: true,
        spaceBetween: 16,
        pagination: {
          // el: '.swiper-pagination',
          clickable: false
        }
      },
      openNewWindows: true,
      targetL: {
        //跳轉地址配置
        column: {
          path: "detail",
          params: [{ name: "id", label: "id"}] //跳轉所需參數
        },
        video: {
          path: "videoDetail",
          params: [{ name: "id", label: "id"}]
        },
        audio: {
          path: "audioDetail",
          params: [{ name: "id", label: "id"}]
        },
        ebook: {
          path: "ebookDetail",
          params: [{ name: "id", label: "id"}]
        }
      }
    };
  },
  watch: {},
  methods: {
    gotoTarget2(ind) {
      let item = this.listsData.items[ind].bookRel;
      //console.log('item',item);
      let types = item.columnCode; //类型
      let dataType = item.dataType; //专辑还是详情
      let target = this.targetL[types];
      if(dataType == 'medialist'){
        target = this.targetL['column'];
      }else{
        target = this.targetL[types];
      }
      // console.log(this.targetL[types]);
      if (target == undefined) {
        //未配置的目標地址
        // console.log("error", "未配置的目標地址");
        return;
      }
      let pArr = target.params;
      let q = {};
      let obj = {};
      obj["path"] = target.path;
      pArr.forEach(p => {
        let val = item[p.name];
        //如果有傳入LABLE則，使用LABEL作為屬性值，沒有則使用name作為參數值
        let key = p.label ? p.label : p.name;
        q[key] = val;
      });
      obj["query"] = q;
      obj["query"]["blockTitle"] = this.title;
      // console.log(obj, q);
      //跳轉音頻詳情頁需要提前判斷是否登錄
      if (types == "audio") {
        if (this.openNewWindows) {
          //新窗口打開
          obj.router = this.$router;
          obj.path = this.$utils.splitUrl(obj.path);
          obj.isTransWindows = true;
          this.GLOBAL_.ccApp.openTo(obj);
        } else {
          //當前窗口打開
          this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
        }
        // });
      } else if (types == "ebook") {
        //新窗口打開,不全屏
        obj.router = this.$router;
        obj.path = this.$utils.splitUrl(obj.path);
        // obj.isTransWindows = true;
        this.GLOBAL_.ccApp.openTo(obj);
      } else {
        if (this.openNewWindows) {
          //新窗口打開
          obj.router = this.$router;
          obj.path = this.$utils.splitUrl(obj.path);
          obj.isTransWindows = true;
          this.GLOBAL_.ccApp.openTo(obj);
        } else {
          //當前窗口打開
          this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
        }
      }
    }
  },
  mounted() {}
};



// WEBPACK FOOTER //
// ./src/components/block/horizontalMax.vue